<template>
  <div>
    <Helper />
    <div class="landing-page">
      <div class="landing-title">
        {{ $t('text.welcome_to_the_group_dashboard') }}
      </div>
      <div>
        <div class="section-card">
          <div class="section-card-title">
            <img class="title-icon w-10" src="@/assets/image/info.png" />
            <span>{{ $t('text.useful_features') }}</span>
          </div>
          <div class="feature-container">
            <el-carousel
              :interval="7000"
              arrow="always"
              height="470px"
              :class="features.length === 1 ? 'signle-feature' : ''"
              :autoplay="autoplay"
            >
              <el-carousel-item
                v-for="feature in features"
                :key="feature.title + feature.order"
              >
                <div class="feature-item">
                  <div class="feature-animation">
                    <img :src="feature.animation" />
                  </div>
                  <div class="feature-content">
                    <div class="feature-title">{{ feature.title }}</div>
                    <div class="feature-desc" v-html="feature.desc"></div>
                    <el-button
                      slot="reference"
                      type="success"
                      class="feature-btn"
                      v-if="feature.showMeMoreContent"
                      @click="showMeMore(feature)"
                      >{{ $t('text.show_me_more') }}</el-button
                    >
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div
          class="section-card"
          v-if="p('Manage Module.Patients.Patients Module.Add')"
          id="quick-actions"
        >
          <div
            class="section-card-title"
            :class="
              $store.getters[`patient/patientsCount`] === 0 ? 'red-title' : ''
            "
          >
            <img
              class="title-icon"
              :src="
                $store.getters[`patient/patientsCount`] === 0
                  ? require('@/assets/image/warning.svg')
                  : require('@/assets/image/quick-action-icon.png')
              "
            />
            <span>{{
              $store.getters[`patient/patientsCount`] === 0
                ? $t('text.attention')
                : $t('text.quick_actions')
            }}</span>
          </div>
          <div
            class="warn-text"
            v-if="$store.getters[`patient/patientsCount`] === 0"
          >
            {{ $t('text.no_patient_warning') }}.
          </div>
          <div
            v-for="action in quickActions"
            :key="action.title"
            class="quick-operate-item"
            @click="action.onClickAction(action.title, action.actionType)"
          >
            <div class="left-icon-wrapper v-h-center">
              <img
                :src="
                  require('@/assets/image/quick-operation-icon/' + action.icon)
                "
              />
            </div>
            <div class="right-content">
              <div class="quick-operate-title">{{ action.title }}</div>
              <div class="quick-operate-desc">{{ action.desc }}</div>
            </div>
          </div>
        </div>
      </div>
      <EditPatient ref="editPatient" />
      <ScrollButton :lessHeightWillShow="800" />
      <component
        :is="currentFeature.showMeMoreContent"
        ref="showMeMore"
        @changeAutoPlay="changeAutoPlay"
      />
    </div>
  </div>
</template>

<script>
import EditPatient from '@/components/manage/patients/EditPatient.vue'
import Helper from '@/components/Helper.vue'
import ScrollButton from '@/components/ScrollButton.vue'
import { patientQuickActions } from '@/const'
import setAreaFilter from '@/components/showMeMore/dashboardLanding/setAreaFilter.vue'
export default {
  data() {
    return {
      currentFeature: {},
      autoplay: true, // Whether the carousel is autoplay
      features: [
        {
          order: 0,
          title: this.$t('text.dashboard_landing_slide1_title'),
          desc: this.$t('text.dashboard_landing_slide1_content'),
          animation: require('@/assets/image/useful-features/dashboard-landing/dashboard-landing-intro.svg'),
          showMeMoreContent: null
        },
        {
          order: 1,
          title: this.$t('text.dashboard_landing_slide2_title'),
          desc: this.$t('text.dashboard_landing_slide2_content'),
          animation: require('@/assets/image/useful-features/dashboard-landing/dashboard-landing-group.svg'),
          showMeMoreContent: null
        },
        {
          order: 2,
          title: this.$t('text.dashboard_landing_slide3_title'),
          desc: this.$t('text.dashboard_landing_slide3_content'),
          animation: require('@/assets/image/useful-features/dashboard-landing/dashboard-landing-wetness-status.svg'),
          showMeMoreContent: null
        },
        {
          order: 3,
          title: this.$t('text.dashboard_landing_slide4_title'),
          desc: this.$t('text.dashboard_landing_slide4_content'),
          animation: require('@/assets/image/useful-features/dashboard-landing/dashboard-landing-other-status.svg'),
          showMeMoreContent: null
        },
        {
          order: 4,
          title: this.$t('text.dashboard_landing_slide5_title'),
          desc: this.$t('text.dashboard_landing_slide5_content'),
          animation: require('@/assets/image/useful-features/dashboard-landing/dashboard-landing-improve-workflow.svg'),
          showMeMoreContent: null
        },
        {
          order: 5,
          title: this.$t('text.dashboard_landing_slide6_title'),
          desc: this.$t('text.dashboard_landing_slide6_content'),
          animation: require('@/assets/image/useful-features/dashboard-landing/dashboard-landing-area-filter.svg'),
          showMeMoreContent: 'setAreaFilter'
        }
      ],
      quickActions: [
        {
          title: this.$t('text.add_patient'),
          desc: this.$t('text.add_patient_quick_action_desc') + '.',
          onClickAction: this.addPatient,
          icon: 'add-patient.png',
          actionType: patientQuickActions.addPatient
        }
      ]
    }
  },
  components: {
    EditPatient,
    Helper,
    ScrollButton,
    setAreaFilter
  },
  methods: {
    showMeMore(feature) {
      this.currentFeature = feature
      // After clicking the show more button, then pause the autoplay of the carousel
      this.changeAutoPlay(false)
      this.$nextTick(() => {
        this.$refs.showMeMore.openDialog()
      })
    },
    addPatient() {
      this.$refs.editPatient.openDialog()
    },
    changeAutoPlay(autoPlay) {
      this.autoplay = autoPlay
    }
  }
}
</script>
